import { cn } from '@/lib/utils';
import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const FullWidthSection = ({ className, children }: Props) => {
  return (
    <div
      className={cn(
        // 'relative left-1/2 w-screen -translate-x-1/2 overflow-visible',
        'relative left-[calc(50vw-12px)] -mx-6 -translate-x-[calc(50vw-12px)] overflow-visible',
        className,
      )}
    >
      <div className="mx-auto w-full max-w-full">{children}</div>
    </div>
  );
};

export default FullWidthSection;
